// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash/fp';

// Utils
import {
    getNotificationBoardTitle,
    getNotificationElementId,
} from '../../../../../../../common/notifications/notificationModelUtils';
import { getTitle } from '../../../../../../../common/elements/utils/elementPropertyUtils';

const StandardNotificationBoardTitle = (props) => {
    const { group, element, notification } = props;

    const groupId = get('id', group);
    const boardId = getNotificationElementId(notification);

    if (groupId === boardId) return null;

    const boardTitle = getTitle(element) || getNotificationBoardTitle(notification);

    if (!boardTitle) return <span> in a board</span>;

    return (
        <span>
            {' '}
            in <span className="board-title">{boardTitle}</span>
        </span>
    );
};

StandardNotificationBoardTitle.propTypes = {
    element: PropTypes.object,
    group: PropTypes.object,
    actors: PropTypes.array,
    notification: PropTypes.object,
};

export default StandardNotificationBoardTitle;
